import { render, staticRenderFns } from "./Publicaciones.vue?vue&type=template&id=5c8c0b80&scoped=true&"
var script = {}
import style0 from "./Publicaciones.vue?vue&type=style&index=0&id=5c8c0b80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8c0b80",
  null
  
)

export default component.exports